export default function gainReward(rewardType, quantity){
	return {
		type: 'GAIN_REWARD',
		rewardType,
		quantity,
	};
}


// WEBPACK FOOTER //
// ./src/actions/gainReward.js